import { GeoJsonProperties } from 'geojson';
import JSDCGeoJSONLayer from '../../Layer/JSDCGeoJSONLayer';
import { useRef } from 'react';
import Event from '../../utils/Event';
import L, { Marker } from 'leaflet';
import { fetchAdvanceListing, fetchQueryAdvanceListing } from './api';
import '../../../components/LeftMenuBar/Layer/LayerItem.scss';
import { AdvanceListingQueryApi } from '../../../apiConfigs/@types';
import { getListingCategoryStyle } from '../../utils/listingCategoryIcon';

export type UseAdvanceListingQueryOptions = {
  advanceClickEvent: Event<GeoJsonProperties>;
  advanceCreateEvent: Event<JSDCGeoJSONLayer>;
  advanceRemoveEvent: Event<JSDCGeoJSONLayer>;
};

const useAdvanceListingQuery = ({
  advanceClickEvent,
  advanceCreateEvent,
  advanceRemoveEvent,
}: UseAdvanceListingQueryOptions) => {
  const advanceListingLayer = useRef<JSDCGeoJSONLayer>(
    new JSDCGeoJSONLayer({
      id: 'advance-listing',
      description: { name: 'advance-listing', type: 'point' },
    }),
  ).current;

  const registerLayerClick = (jsdcLayer: JSDCGeoJSONLayer) => {
    jsdcLayer.forEachLayerAsGeoJSON<Marker, { [k: string]: any }>((layer, properties) => {
      const { icon, color } = getListingCategoryStyle(properties?.listing_category);
      layer.setIcon(
        L.divIcon({
          html: `<div class="cat-icon" style="background:${color}"><i class="las ${icon}"></i></div>`,
          className: 'cat-icon-wrap',
          iconSize: [32, 32],
          iconAnchor: [16, 16],
        }),
      );
      layer.on('click', async () => {
        advanceClickEvent.raise(properties);
      });
    });
  };

  const clearAdvanceListing = () => {
    advanceRemoveEvent.raise(advanceListingLayer);
    advanceListingLayer.instance
      ?.getLayers()
      .forEach((layer) => advanceListingLayer.instance?.removeLayer(layer));
  };

  const getAll = async () => {
    const geojsonObject = await fetchAdvanceListing();
    advanceListingLayer.addFeature(geojsonObject);
    registerLayerClick(advanceListingLayer);
    advanceCreateEvent.raise(advanceListingLayer);
    return advanceListingLayer;
  };

  const queryAdvance = async (
    options: AdvanceListingQueryApi['Request'],
    reportStartDate: string,
    reportEndDate: string,
    occurence: string[],
  ) => {
    const geojsonObject = await fetchQueryAdvanceListing(
      options,
      reportStartDate,
      reportEndDate,
      occurence,
    );
    advanceListingLayer.addFeature(geojsonObject);
    registerLayerClick(advanceListingLayer);
    advanceCreateEvent.raise(advanceListingLayer);
    return advanceListingLayer;
  };

  return {
    advanceListingLayer,
    getAll,
    queryAdvance,
    clearAdvanceListing,
  };
};

export default useAdvanceListingQuery;
